
<template>
  <el-dialog title="分配班级" :visible.sync="showDistribution" width="40%" class="distribution_dialog" :show-close='false' :close-on-click-modal="false">
    <el-form :model="form" :rules="rules" :label-width="formLabelWidth">
      <el-form-item label="班级"  prop="selected">
        <el-select v-model="form.selected" filterable placeholder="请选择班级">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in classArr" :key="index"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="concel">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'distributionClass',
  components: {
  },
  data(){
    return {
      // showDistribution: false,
      formLabelWidth: '120px',
      form:{
        selected:''
      },
      classArr:[],
      rules:{
        selected:[
          { required: true, message: '请选择班级', trigger: 'change' }
        ],
      }
    }
  },
  props:{
    showDistribution:{
      type:Boolean
    },
    id:{
      type:String
    },
  },
  created(){
    let classParams = {
        period_id:Number(this.id)
      }
      this.obtainClass(classParams)
  },
  mounted(){
  },
  methods:{
    obtainClass(params){
      this.$api.user.classSelectList(params)
      .then(res=>{
        if(res.code === 0){
          this.classArr = res.result
        }
      }) 
    },
    confirm(){
      this.$emit('distributionConfirm',this.form.selected)
    },
    concel(){
      this.$emit('distributionConcel',this.showDistribution)
    },
  },
    
}
</script>
<style lang="scss" scoped>
  // @import '../../../assets/scss/content.scss';
  .distribution_dialog .el-select{
    width:90%;
  }
</style>